export default () => (
  <div className="absolute animate-spin w-full h-full border-b-4 rounded-full border-gray-400" />
);
